import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { $crud } from "../../utils/CrudFactory";
import { usePagination } from "../../hooks";
import DynamicTable from "../../components/DynamicTable";
import { helpOfferFilters, orderFilters } from "../../utils/filterConfig";
import { Visibility, Delete, VisibilityOff } from "@mui/icons-material";
import HelpOfferModal from "../../components/modals/HelpOfferModal";
import { toLocalTime } from "../../helper/functions";

export default function HelpOffers() {
  const navigate = useNavigate();
  const [expandedRows, setExpandedRows] = useState([]);
  const [rows, setRows] = useState([]); //STATE TO GET THE ORDER LIST
  const [selectedRow, setSelectedRow] = useState(null);
  const [isFilter, setIsFilter] = useState(false);
  const [openHelpOfferModal, setOpenHelpOfferModal] = useState(false);
  const { page, limit, setLimit, setPage, total, setTotal } = usePagination(); // PAGINATION PROPS
  const location = useLocation();
  // STATE TO MANAGE FILTERS --------------------------------------
  const [filtrationData, setFiltrationData] = useState({
    from: "",
    to: "",
    stage: "",
  });
  // STATE TO MANAGE FILTERS --------------------------------------
  async function retrieveData() {
    const isFilterApplied = Object.values(filtrationData).some(
      (value) => value !== ""
    );

    const params = {
      from: filtrationData.from,
      to: filtrationData.to,
      stage: filtrationData.stage,
    };

    // Conditionally include limit and page if no filters are applied
    if (!isFilterApplied) {
      params.limit = 0;
      params.page = 0;
    }

    const { data } = await $crud.retrieve("admin/help-offers", params);
    return data;
  }
  useEffect(() => {
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
    retrieveData().then((res) => {
      setRows(res.result);
      setTotal(res.total);
    });
    // RUNNING THE retrieveData() FUNCTION ---------------------------------
  }, [limit, page, filtrationData]);

  const handleOpenHelpOfferModal = (row) => {
    setSelectedRow(row);
    setOpenHelpOfferModal(true);
  };

  // function to close position modal---------------------------------
  const handleCloseModal = () => {
    setOpenHelpOfferModal(false);
    setSelectedRow(null);
  };

  // function to call the api and update the comment -------------------------------------
  const handleOfferSubmit = async (reason) => {
    // Logic to update position with reason
    const { data, type } = await $crud.put(`admin/help-offer-archieve`, {
      id: selectedRow._id,
    });
    if (type == "success") {
      retrieveData().then((res) => {
        setRows(res.result);
        setTotal(res.total);
      });
    }
    // handleCloseModal();
  };

  // COLUMNS IN THE ORDER TABLE-----------------------------
  const clientColumns = [
    {
      id: "offerName",
      label: "Offer Name",
      align: "center",
    },
    {
      id: "createdOn",
      label: "Created On",
      align: "center",
      renderCell: (row) => toLocalTime(row.createdOn),
    },
    {
      id: "stage",
      label: "Status",
      align: "center",
      renderCell: (row) => {
        const getStatusStyles = (status) => {
          switch (status) {
            case "Active":
              return {
                background: "rgba(7, 79, 36, 0.35)",
              };
            case "Archived":
              return {
                background: "rgba(104, 60, 140, 0.5)",
              };
            case "Expired":
              return {
                background: "rgba(251, 189, 189, 1)",
              };
            default:
              return {
                background: "#FFF0ED",
              };
          }
        };
        const styles = getStatusStyles(row.stage);
        return (
          <Button
            sx={{
              background: styles.background,
              borderRadius: "22px",
              color: "rgba(23, 26, 31, 1)",
              padding: "7px 27px",
              cursor: "auto",
              textTransform: "capitalize",
              border: "none",
              fontSize: "12px",
              width: "100px",
              outline: "none !important",
              "&:hover": {
                outline: styles.background,
                background: styles.background,
              },
              "&:focus": {
                outline: styles.background,
                background: styles.background,
              },
            }}
          >
            {row.stage}
          </Button>
        );
      },
    },
    {
      id: "listingPosition",
      label: "Position",
      align: "center",
    },
    {
      id: "action",
      label: "View",
      align: "center",
      renderCell: (row) => {
        const isRowExpanded = expandedRows.includes(row._id);
        return (
          <>
            {isRowExpanded ? (
              <IconButton
                sx={{
                  fontSize: "8px",
                  color: "rgba(104, 60, 140, 1)",
                }}
                onClick={() => handleExpandRow(row._id)}
                // Add your onClick logic for delete here
              >
                <VisibilityOff />
              </IconButton>
            ) : (
              <IconButton
                sx={{ fontSize: "8px", color: "rgba(104, 60, 140, 1)" }}
                onClick={() => handleExpandRow(row._id)}
              >
                <Visibility />
              </IconButton>
            )}
          </>
        );
      },
    },
    {
      id: "action",
      label: "Archive",
      align: "center",
      renderCell: (row) => {
        const isRowExpanded = expandedRows.includes(row._id);
        return (
          <>
            <IconButton
              sx={{ fontSize: "8px", color: "rgba(104, 60, 140, 1)" }}
              onClick={(e) => handleOpenHelpOfferModal(row)}
            >
              <Delete />
            </IconButton>
          </>
        );
      },
    },
  ];
  // COLUMNS IN THE ORDER TABLE-----------------------------

  const dummyData = [
    {
      id: "66951a42982521f9f32165f2",
      offerName: "testttttttttt",
      stage: "Active",
      usedBy: "20",
      subscribers: "39",
      savedValue: "32 690,00",
      startDate: "Jun 30, 2024",
      expireDate: "Jul 16, 2024",
      discountDetails: "test",
      archived: false,
      offerDetails: "<b>dhfdsbfjks</b>",
      createdOn: "Jul 15, 2024",
    },
  ];

  const handleExpandRow = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  useEffect(() => {
    if (location.state?.id) {
      setTimeout(() => {
        setExpandedRows((prev) => [...prev, location.state?.id]);
      }, 1000);
    }
  }, [location.state]);

  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  const getFilteredData = (data) => {
    if (!data.stage) data.stage = "";
    setFiltrationData({
      ...filtrationData,
      ...data,
    });
    setIsFilter(true);
    setPage(0);
  };
  // FUNCTION TO SET THE FILTERS IN filtrationData STATE -----------------------------
  return (
    <>
      <Grid container sx={{ padding: "0 18px" }}>
        <Grid item xs={12} md={6}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "30px",
              color: "#673C8E", // Return the value directly
            }}
          >
            Help Offers
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            paddingRight: "24px",
            display: "flex",
            justifyContent: "end",
            alignItems: "end",
            gap: "15px",
          }}
        >
          <Button
            onClick={() => navigate("add")}
            variant="outlined"
            size="small"
            sx={{
              padding: "10px 40px",
              textTransform: "capitalize",
              backgroundColor: "transparent",
              color: "rgba(103, 60, 142, 1)",
              borderColor: "rgba(103, 60, 142, 1)",
              borderRadius: "4px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "transparent",
                color: "rgba(103, 60, 142, 1)",
                borderColor: "rgba(103, 60, 142, 1)",
              },
            }}
          >
            Create New Offer
          </Button>
          <Button
            onClick={() => navigate("/services/regular-offers")}
            variant="contained"
            size="small"
            sx={{
              padding: "10px 26px",
              textTransform: "capitalize",
              backgroundColor: "rgba(103, 60, 142, 1)",
              color: "#fff",
              borderRadius: "4px",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "rgba(103, 60, 142, 1)",
                color: "#fff",
              },
            }}
          >
            Go To Regular Offers
          </Button>
        </Grid>
      </Grid>
      <Box sx={{ paddingRight: "24px" }}>
        <DynamicTable
          rows={rows}
          type="helpOffers"
          url="help-offers"
          setRows={setRows}
          filterConfig={helpOfferFilters} // Pass the filter checkbox options
          noRecordTitle="No help offers yet!" // no data title
          onFilterData={getFilteredData} // filteration data
          isFilter={isFilter}
          onResetFilters={() => {
            setFiltrationData((prev) => ({
              from: "",
              to: "",
              stage: "",
            }));
            setIsFilter(false);
          }}
          onSearchData={(value) =>
            setFiltrationData({ ...filtrationData, search: value })
          }
          filtrationData={filtrationData}
          // isFilter={isFilter}
          paginationProps={{ limit, page, setLimit, setPage, total, setTotal }}
          columns={clientColumns} // Pass the columns prop
          expandedRows={expandedRows}
          handleExpandRow={handleExpandRow}
        />
      </Box>
      {openHelpOfferModal && selectedRow && (
        <HelpOfferModal
          open={openHelpOfferModal}
          archived={selectedRow.archived}
          onSubmit={handleOfferSubmit}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}
